import React, { createRef } from 'react';
import Lightbox from '@cratejoy/lightbox';
import PropTypes from 'prop-types';
import Stats from 'frontend_stats';

import {
	GalleryWrapper
} from "./galleryStyles";
import Thumbs from "./thumbs";

import aspectRatio from './aspectRatio';
import FullstoryUtil from "fullstory_util";

class SecondaryOnlyGallery extends React.Component {

	state = {
		activeSlide: 0
	};

	slideTrigger = (index) => {
		Stats.trackGeneric('review-gallery', {
			step_name: 'carousel_moved'
		});
		FullstoryUtil.sendEvent('Review Gallery Carousel Moved');
		this.setState({
			activeSlide: index,
		});
	};
	trackedOpenByIndex = (openByIndex) => {
		return (idx) => {
			Stats.trackGeneric('review-gallery', {
				step_name: 'opened_lightbox'
			});
			FullstoryUtil.sendEvent('Review Gallery Lightbox Opened');
			return openByIndex(idx);
		};
	};
	processRatio = ratio => {
		const { processRatio, defaultProps } = this;
		if (typeof ratio !== 'string') return processRatio(defaultProps.aspectRatio);
		const exploded = ratio.split(':').map(n => Number(n)); // [ 16, 9 ]
		const appliedRatio = exploded[1] / exploded[0] * 100; // 9/16
		return `${appliedRatio}%`; // '56.25%'
	};

	render() {

		const { media, thumbsRatio } = this.props;
		const { activeSlide } = this.state;
		const thumbsR = this.processRatio(thumbsRatio);

		return media.length && (
			<GalleryWrapper>
				<Lightbox src={media}>
					{({ openByIndex }) => (
						<Thumbs
							activeSlide={activeSlide}
							media={media}
							slideTrigger={this.slideTrigger}
							openOnClick={this.trackedOpenByIndex(openByIndex)}
							ratio={thumbsR}
							lazy
						/>
					)}
				</Lightbox>
			</GalleryWrapper>
		);
	}
}

SecondaryOnlyGallery.propTypes = {
	media: PropTypes.arrayOf(PropTypes.shape({
		url: PropTypes.string.isRequired,
		name: PropTypes.string,
		isImage: PropTypes.bool,
		thumbnail: PropTypes.string,
	})).isRequired,
	thumbsRatio: aspectRatio,
};

SecondaryOnlyGallery.defaultProps = {
	thumbsRatio: '1:1'
};

export default SecondaryOnlyGallery;
